import { createFileRoute } from "@tanstack/react-router";
import { RelatorioFichaProdutor } from "pages/relatorios/pages/ficha_produtor";

export const Route = createFileRoute("/a/relatorios/ficha-produtor")({
	component: RelatorioFichaProdutor,
});
